/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const AppMobile = lazyLoad(
  () => import('./index'),
  module => module.AppMobile
);
